import {
  AddScheduleActionTypes,
  EMAIL_OTP_GEN_FAIL,
  EMAIL_OTP_GEN_LOADING,
  EMAIL_OTP_GEN_SUCCESS,
  AddScheduleState,
  EMAIL_OTP_GEN_UPDATE_API_MSG,
  EMAIL_OTP_GEN_UPDATE_API_RES,
} from "./ActionTypes";
import { emailOtpGenRes } from "./Model";

const initialStateGetPosts: AddScheduleState = {
  loading: false,
  emailOTPGenRes: {} as emailOtpGenRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const emailOtpgenerationReducer = (
  state = initialStateGetPosts,
  action: AddScheduleActionTypes
): AddScheduleState => {
  switch (action.type) {
    case EMAIL_OTP_GEN_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EMAIL_OTP_GEN_SUCCESS:
      return {
        ...state,
        emailOTPGenRes: action.payload,
        successMsg: action.successMsg,
      };
    case EMAIL_OTP_GEN_FAIL:
      return {
        ...state,
        emailOTPGenRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EMAIL_OTP_GEN_UPDATE_API_MSG:
      return {
        ...state,
        emailOTPGenRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EMAIL_OTP_GEN_UPDATE_API_RES:
      return {
        ...state,
        emailOTPGenRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};

